import { render } from "./Foiv.vue?vue&type=template&id=6b320cb4"
import script from "./Foiv.vue?vue&type=script&lang=js"
export * from "./Foiv.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__